import React, { useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import DOMPurify from 'dompurify';

const SimpleModal = (props) => {
    const [modal, setModal] = useState(false);

    const toggle = () => {
        setModal(!modal);
    };

    const { modalTitle, buttonText, modalBody, actionClassName, modalClassName, modalBodyOverride } = props;
    return (
        <div>
            <a className={actionClassName ? actionClassName : 'btn btn-light jr-btn-rounded'} href='javascript:void(0)' onClick={toggle}>{buttonText}</a>
            <div className="text-center">
                <Modal isOpen={modal} toggle={toggle} className={modalClassName}>
                    <ModalHeader>{modalTitle}</ModalHeader>
                    <ModalBody>
                        {modalBodyOverride ?
                            modalBodyOverride :
                            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(modalBody) }} />
                        }
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={toggle}>Close</Button>
                    </ModalFooter>
                </Modal>
            </div>
        </div>
    );
};


export default SimpleModal;


// WEBPACK FOOTER //
// ./components/simpleModal/index.js